import { setContext, getContext } from "svelte";
import {
  fetchConfiguration,
  defaultConfiguration,
  type Configuration,
} from "./configuration";

//NOTE! See docs/ConfigurationContext.md for some important details and deep Svelte Lore!
// TODO - switch to new `export const [getTContext, setTContext] = createContext<T>();` API: https://svelte.dev/docs/svelte/context#Type-safe-context

const configKey = Symbol("config");
const CONFIG_POLL_INTERVAL_MS =
  Number(import.meta.env.VITE_CONFIG_POLL_INTERVAL_MS) || 30 * 60 * 1000; // 30 minutes

function fetchAndSetConfigurationContext(
  displayId: () => string
): Configuration {
  let config = $state(defaultConfiguration());
  let intervalId: NodeJS.Timeout | null = null;

  function fetchAndUpdateConfig(id: string): void {
    if (!id) return;
    fetchConfiguration(id).then((c) => {
      Object.assign(config, c); // don't spread here! We need to mutate the object to trigger reactivity
    });
  }

  $effect(() => {
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(() => {
      fetchAndUpdateConfig(displayId());
    }, CONFIG_POLL_INTERVAL_MS);
    fetchAndUpdateConfig(displayId());

    // Cleanup function to clear the interval
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };
  });

  setContext(configKey, config);
  return getConfigurationContext();
}

/** @example const config = getConfigurationContext();
 * <p> Some setting: {config.settings.someSetting} </p>
 *
 * // ❌ Don't do this - breaks reactivity:
 * // const { settings } = config;
 * // const { someSetting } = settings;
 */
function getConfigurationContext(): Configuration {
  return getContext(configKey);
}

export { fetchAndSetConfigurationContext, getConfigurationContext, configKey };
